import { yodaMessageCostants } from "../constants";
import { yodaMessagesService } from "../services";
import { history } from "../../utils";
import { yodaUtilsActions } from "./yodaUtils.actions";

export const yodaMessageActions = {
  getMessages,
  clearMessages,
};

function getMessages(customerId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaMessagesService.getMessages(customerId).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaMessagesService.getMessages",
      { customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaMessageCostants.GET_MESSAGE_REQUEST };
  }

  function success(messages) {
    return {
      type: yodaMessageCostants.GET_MESSAGE_SUCCESS,
      payload: { messages },
    };
  }

  function failure(error) {
    return { type: yodaMessageCostants.GET_MESSAGE_REQUEST_FAILURE };
  }
}

function clearMessages() {
  return (dispatch) => {
    dispatch(success());

    function success() {
      return { type: yodaMessageCostants.CLEAR_MESSAGE_REQUEST_SUCCESS };
    }
  };
}
